module.exports = __webpack_public_path__ + "static/media/infoJumbo3.7a842af0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/fehlmann/images/infoJumbo3.jpg
// module id = 485
// module chunks = 0